import React from "react";
import { Flex } from "@chakra-ui/react";
import { Button } from "components/RFQ/Button";
const MenuBarComp = ({ setShowDialog, ...props }) => {
	return (
		<>
			<Flex
				gap={4}
				{...props}
			>
				<Button
					btntype="primary"
					onClick={() => setShowDialog("accept")}
					data-testid="accept-button"
				>
					<div className="font-roboto font-semibold text-white">
						Accept Invitation
					</div>
				</Button>
				<Button
					btntype="secondary"
					onClick={() => setShowDialog("decline")}
					data-testid="decline-button"
				>
					<div className="font-roboto font-semibold text-utility-blue-dark-100">
						Decline Invitation
					</div>
				</Button>
			</Flex>
		</>
	);
};

export default MenuBarComp;
